/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { opexesVariantsCopyCreate } from '../fn/opexs-variants/opexes-variants-copy-create';
import { OpexesVariantsCopyCreate$Params } from '../fn/opexs-variants/opexes-variants-copy-create';
import { opexesVariantsCreate } from '../fn/opexs-variants/opexes-variants-create';
import { opexesVariantsCreate$FormData } from '../fn/opexs-variants/opexes-variants-create-form-data';
import { OpexesVariantsCreate$FormData$Params } from '../fn/opexs-variants/opexes-variants-create-form-data';
import { OpexesVariantsCreate$Params } from '../fn/opexs-variants/opexes-variants-create';
import { opexesVariantsCreate$XWwwFormUrlencoded } from '../fn/opexs-variants/opexes-variants-create-x-www-form-urlencoded';
import { OpexesVariantsCreate$XWwwFormUrlencoded$Params } from '../fn/opexs-variants/opexes-variants-create-x-www-form-urlencoded';
import { opexesVariantsDestroy } from '../fn/opexs-variants/opexes-variants-destroy';
import { OpexesVariantsDestroy$Params } from '../fn/opexs-variants/opexes-variants-destroy';
import { opexesVariantsList } from '../fn/opexs-variants/opexes-variants-list';
import { OpexesVariantsList$Params } from '../fn/opexs-variants/opexes-variants-list';
import { opexesVariantsPartialUpdate } from '../fn/opexs-variants/opexes-variants-partial-update';
import { opexesVariantsPartialUpdate$FormData } from '../fn/opexs-variants/opexes-variants-partial-update-form-data';
import { OpexesVariantsPartialUpdate$FormData$Params } from '../fn/opexs-variants/opexes-variants-partial-update-form-data';
import { OpexesVariantsPartialUpdate$Params } from '../fn/opexs-variants/opexes-variants-partial-update';
import { opexesVariantsPartialUpdate$XWwwFormUrlencoded } from '../fn/opexs-variants/opexes-variants-partial-update-x-www-form-urlencoded';
import { OpexesVariantsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs-variants/opexes-variants-partial-update-x-www-form-urlencoded';
import { opexesVariantsRetrieve } from '../fn/opexs-variants/opexes-variants-retrieve';
import { OpexesVariantsRetrieve$Params } from '../fn/opexs-variants/opexes-variants-retrieve';
import { opexesVariantsUpdate } from '../fn/opexs-variants/opexes-variants-update';
import { opexesVariantsUpdate$FormData } from '../fn/opexs-variants/opexes-variants-update-form-data';
import { OpexesVariantsUpdate$FormData$Params } from '../fn/opexs-variants/opexes-variants-update-form-data';
import { OpexesVariantsUpdate$Params } from '../fn/opexs-variants/opexes-variants-update';
import { opexesVariantsUpdate$XWwwFormUrlencoded } from '../fn/opexs-variants/opexes-variants-update-x-www-form-urlencoded';
import { OpexesVariantsUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs-variants/opexes-variants-update-x-www-form-urlencoded';
import { BackendOpexVariantDto } from '../models/backend-opex-variant-dto';
import { BackendOpexVariantResponseDto } from '../models/backend-opex-variant-response-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiOpexsVariantsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `opexesVariantsList()` */
  static readonly OpexesVariantsListPath = '/api/opexes/variants/';

  /**
   * Список и создание вариантов расходов.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesVariantsList$Response(
    params: OpexesVariantsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendOpexVariantResponseDto>>> {
    return opexesVariantsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Список и создание вариантов расходов.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesVariantsList(
    params: OpexesVariantsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendOpexVariantResponseDto>> {
    return this.opexesVariantsList$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<Array<BackendOpexVariantResponseDto>>): Array<BackendOpexVariantResponseDto> => r.body,
      ),
    );
  }

  /** Path part for operation `opexesVariantsCreate()` */
  static readonly OpexesVariantsCreatePath = '/api/opexes/variants/';

  /**
   * Список и создание вариантов расходов.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesVariantsCreate$Response(
    params: OpexesVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantResponseDto>> {
    return opexesVariantsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Список и создание вариантов расходов.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesVariantsCreate(
    params: OpexesVariantsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantResponseDto> {
    return this.opexesVariantsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantResponseDto>): BackendOpexVariantResponseDto => r.body),
    );
  }

  /**
   * Список и создание вариантов расходов.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesVariantsCreate$XWwwFormUrlencoded$Response(
    params: OpexesVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantResponseDto>> {
    return opexesVariantsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Список и создание вариантов расходов.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesVariantsCreate$XWwwFormUrlencoded(
    params: OpexesVariantsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantResponseDto> {
    return this.opexesVariantsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantResponseDto>): BackendOpexVariantResponseDto => r.body),
    );
  }

  /**
   * Список и создание вариантов расходов.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesVariantsCreate$FormData$Response(
    params: OpexesVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantResponseDto>> {
    return opexesVariantsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Список и создание вариантов расходов.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesVariantsCreate$FormData(
    params: OpexesVariantsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantResponseDto> {
    return this.opexesVariantsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantResponseDto>): BackendOpexVariantResponseDto => r.body),
    );
  }

  /** Path part for operation `opexesVariantsRetrieve()` */
  static readonly OpexesVariantsRetrievePath = '/api/opexes/variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesVariantsRetrieve$Response(
    params: OpexesVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return opexesVariantsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesVariantsRetrieve(
    params: OpexesVariantsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.opexesVariantsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /** Path part for operation `opexesVariantsUpdate()` */
  static readonly OpexesVariantsUpdatePath = '/api/opexes/variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesVariantsUpdate$Response(
    params: OpexesVariantsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return opexesVariantsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesVariantsUpdate(params: OpexesVariantsUpdate$Params, context?: HttpContext): Observable<BackendOpexVariantDto> {
    return this.opexesVariantsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesVariantsUpdate$XWwwFormUrlencoded$Response(
    params: OpexesVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return opexesVariantsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesVariantsUpdate$XWwwFormUrlencoded(
    params: OpexesVariantsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.opexesVariantsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesVariantsUpdate$FormData$Response(
    params: OpexesVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return opexesVariantsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesVariantsUpdate$FormData(
    params: OpexesVariantsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.opexesVariantsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /** Path part for operation `opexesVariantsDestroy()` */
  static readonly OpexesVariantsDestroyPath = '/api/opexes/variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesVariantsDestroy$Response(
    params: OpexesVariantsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return opexesVariantsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesVariantsDestroy(params: OpexesVariantsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.opexesVariantsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `opexesVariantsPartialUpdate()` */
  static readonly OpexesVariantsPartialUpdatePath = '/api/opexes/variants/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesVariantsPartialUpdate$Response(
    params: OpexesVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return opexesVariantsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesVariantsPartialUpdate(
    params: OpexesVariantsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.opexesVariantsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesVariantsPartialUpdate$XWwwFormUrlencoded$Response(
    params: OpexesVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return opexesVariantsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesVariantsPartialUpdate$XWwwFormUrlencoded(
    params: OpexesVariantsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.opexesVariantsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesVariantsPartialUpdate$FormData$Response(
    params: OpexesVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return opexesVariantsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesVariantsPartialUpdate$FormData(
    params: OpexesVariantsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.opexesVariantsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }

  /** Path part for operation `opexesVariantsCopyCreate()` */
  static readonly OpexesVariantsCopyCreatePath = '/api/opexes/variants/{id}/copy/';

  /**
   * Копирование варианта расходов.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesVariantsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesVariantsCopyCreate$Response(
    params: OpexesVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendOpexVariantDto>> {
    return opexesVariantsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Копирование варианта расходов.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesVariantsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesVariantsCopyCreate(
    params: OpexesVariantsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendOpexVariantDto> {
    return this.opexesVariantsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendOpexVariantDto>): BackendOpexVariantDto => r.body),
    );
  }
}
